module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAOUlEQVQ4T2N0dnb+z0AlwAgybPPmzRQb5+vryzBqGGnBOBpmpIUXSPVomI2GGY4QoE3SID24sesAANB+VOzQuFrsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/check.png
// module id = mbzP
// module chunks = 1